module.exports = __webpack_public_path__ + "static/img/falseIcon.f8b51c42.png";